// Import the functions you need from the SDKs you need
// import { config } from "dotenv";
import { initializeApp } from "firebase/app";
import { getToken, getMessaging, deleteToken } from "firebase/messaging";
import { subscribeToTopic } from "Listfunction";
// import { config } from "dotenv";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// config();

const firebaseConfig = {
  apiKey: "AIzaSyCaFYp_QrRefEg9RVmHO7ALsiyTgmgNa4Q",
  authDomain: "flash-health.firebaseapp.com",
  projectId: "flash-health",
  storageBucket: "flash-health.appspot.com",
  messagingSenderId: "427822585917",
  appId: "1:427822585917:web:182f52abc4b0f54da13254",
  measurementId: "G-3HZD9FDTWN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const generateToken = async (notificationSystem) => {
  const addNotification = (message, level) => {
    notificationSystem.addNotification({
      message,
      level,
      position: "tr",
      autoDismiss: 10,
    });
  };

  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    try {
      const currentToken = await getToken(messaging, {
        vapidKey:
          "BLNWfGfF6WKiq8S8qv8zV4iLm_QK0zhShDfDufxQDcpU9zNuQxTXNlQLCpLeXkSrycJaGtcer_qi5v2wXI4QlX4",
      });
      if (currentToken) {
        // Subscribe the user to a topic
        const user = JSON.parse(localStorage.getItem("user"));
        if (user.token) {
          await subscribeToTopic(user.token, {
            token: currentToken,
            topic: process.env.REACT_APP_FIREBASE_MESSAGING_TOPIC,
          });
        }
      } else {
        addNotification(
          "Something wrong for notifications please contact the administrator",
          "warning"
        );
      }
    } catch (err) {
      addNotification(`An error occurred while retrieving token`, "error");
    }
  } else {
    addNotification("Please turn on notifications on your browser", "error");
  }
};

export const deleteFirebaseToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        "BLNWfGfF6WKiq8S8qv8zV4iLm_QK0zhShDfDufxQDcpU9zNuQxTXNlQLCpLeXkSrycJaGtcer_qi5v2wXI4QlX4",
    });
    if (currentToken) {
      await deleteToken(messaging);
    }
  } catch (error) {
    return error;
  }
};
